import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import Features from './components/sections/Features';
import Benefits from './components/sections/Benefits';
import Products from './components/sections/Products';
import Testimonials from './components/sections/Testimonials';
import Footer from './components/layout/Footer';
import FeaturesGrid from './components/sections/FeaturesGrid';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Benefits />
        <Products />
        <FeaturesGrid />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}

export default App; 